"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDetailsPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var PoliciesTree_1 = require("./PoliciesTree");
var components_1 = require("@athena-portal/components");
var CustomerNotes_1 = require("./customerNotes/CustomerNotes");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Confirmation_1 = require("../Confirmation");
var react_router_dom_1 = require("react-router-dom");
var Page_1 = require("../Page");
var operators_1 = require("rxjs/operators");
var services_1 = require("@falcon/services");
var DeceasedCustomerAction_1 = require("./actions/DeceasedCustomerAction");
var ShowLoginActivitiesAction_1 = require("./actions/ShowLoginActivitiesAction");
var ShowAgentActivitiesAction_1 = require("./actions/ShowAgentActivitiesAction");
var LockUserAction_1 = require("./actions/LockUserAction");
var SetTemporaryPasswordAction_1 = require("./actions/SetTemporaryPasswordAction");
var Tree_1 = require("../../components/Tree");
var TreeRoot_1 = require("../../components/TreeRoot");
var CustomerDetailsPagePlain = /** @class */ (function (_super) {
    __extends(CustomerDetailsPagePlain, _super);
    function CustomerDetailsPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.readonlyRole = !_this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR"]);
        _this.renderPageContent = function () {
            var customer = _this.state.customer;
            if (!customer) {
                return (0, jsx_runtime_1.jsx)("h3", { children: "Customer not found!" });
            }
            document.title = "".concat(customer.firstName, " ").concat(customer.lastName, " details");
            var customerName = "".concat(customer.firstName, " ").concat(customer.lastName);
            return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "row panel-border", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-12 col-md-8 pb-3 pl-0 pr-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "customer-tree", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("b", { children: [customer.firstName, " ", customer.lastName] }), " (", customer.email, ")", (0, jsx_runtime_1.jsx)("i", { title: "Copy user ID", className: "icon-button fas ".concat(_this.state.userIdIsCopied ? 'fa-file-check' : 'fa-copy', " ml-2"), id: "copyUserID", onClick: function () {
                                                    navigator.clipboard.writeText(_this.customerId).then(function () {
                                                        _this.setState({ userIdIsCopied: true });
                                                        setTimeout(function () {
                                                            _this.setState({ userIdIsCopied: false });
                                                        }, 2000);
                                                    }).catch(function (err) {
                                                        console.error('Failed to copy userID: ', err);
                                                    });
                                                } }), _this.supportPortalTemplates.userHasRole(["Administrator"]) &&
                                                (0, jsx_runtime_1.jsx)("i", { title: "Open Keycloak", className: "icon-button fas fa-key ml-2", id: "openKeycloak", onClick: function () {
                                                        window.open("".concat(process.env.REACT_APP_KEYCLOAK_URL, "/admin/master/console/#/").concat(process.env.REACT_APP_KEYCLOAK_CUSTOMER_PORTAL_REALM, "/users/").concat(_this.customerId, "/settings"), '_blank');
                                                    }, role: "none" }), (0, jsx_runtime_1.jsxs)("div", { children: ["Documents preference: ", _this.getDocumentsPreference()] }), _this.state.fraudFlag && (0, jsx_runtime_1.jsx)("span", { className: "ml-2", children: "\uD83D\uDEA9" }), _this.state.vulnerableCustomerFlag &&
                                                (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold ml-2", children: "VC" }), _this.state.deceasedFlag && (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold ml-2", children: "Deceased" })] }), (0, jsx_runtime_1.jsxs)(TreeRoot_1.TreeRoot, { children: [_this.renderActionsTree(), (0, jsx_runtime_1.jsx)(PoliciesTree_1.default, { customerReferenceNumber: _this.customerId, policies: _this.state.policies, renewalProposals: _this.state.renewalProposals, customer: customer, vulnerableCustomerFlag: _this.state.vulnerableCustomerFlag, onActionChange: _this.onActionChange, showLoader: _this.incrementLoadingQueueSize, hideLoader: _this.decrementLoadingQueueSize })] })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-12 col-md-4 pb-3 mt-3 mt-md-0 border-left", children: !_this.readonlyRole && (0, jsx_runtime_1.jsx)(CustomerNotes_1.default, { customerReferenceNumber: _this.customerId }) }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showVulnerableCustomerFlagConfirmation, hide: function () { return _this.setState({ showVulnerableCustomerFlagConfirmation: false }); }, confirm: _this.toggleVulnerableCustomerFlag, title: "", message: "Are you sure you want to ".concat(!_this.state.vulnerableCustomerFlag ? "FLAG" : "UNFLAG", " ").concat(customerName, " as vulnerable customer?") }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showFraudFlagConfirmation, hide: function () { return _this.setState({ showFraudFlagConfirmation: false }); }, confirm: _this.toggleFraudFlag, title: "", message: "Are you sure you want to ".concat(!_this.state.fraudFlag ? "FLAG" : "UNFLAG", " ").concat(customerName, " as fraud?") })] }) }));
        };
        _this.renderActionsTree = function () {
            var _a, _b, _c;
            var actions = [];
            if (_this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler"])) {
                actions.push((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", to: "/customers/".concat(_this.customerId, "/claims"), children: "Claims" }, "Claims action"));
                actions.push((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", to: "/customers/".concat(_this.customerId, "/underwritingUpdates"), state: {
                        policies: _this.state.policies,
                        customerName: ((_a = _this.state.customer) === null || _a === void 0 ? void 0 : _a.firstName) + " " + ((_b = _this.state.customer) === null || _b === void 0 ? void 0 : _b.lastName)
                    }, children: "Underwriting updates" }, "Underwriting updates action"));
            }
            _this.handleFraudAction(actions);
            if (_this.supportPortalTemplates.userHasRole(["Administrator", "Fraud", "Support", "CSR_Lead", "CSR", "Read_Only"])) {
                actions.push((0, jsx_runtime_1.jsx)(ShowLoginActivitiesAction_1.default, { customerId: _this.customerId }, "Show login activities action"));
                actions.push((0, jsx_runtime_1.jsx)(ShowAgentActivitiesAction_1.default, { customerId: _this.customerId }, "Show agent activities action"));
            }
            if (_this.supportPortalTemplates.userHasRole(["Administrator", "CSR_Lead", "CSR"])) {
                actions.push((0, jsx_runtime_1.jsx)(LockUserAction_1.default, { customerId: _this.customerId, showLoader: _this.incrementLoadingQueueSize, hideLoader: _this.decrementLoadingQueueSize }, "Lock user action"));
                actions.push((0, jsx_runtime_1.jsx)(SetTemporaryPasswordAction_1.default, { customerId: _this.customerId, showLoader: _this.incrementLoadingQueueSize, hideLoader: _this.decrementLoadingQueueSize }, "Set temporary password action"));
            }
            if (_this.state.policies
                && _this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support"])
                && (_this.state.policies.some(function (p) { return p.products.includes(services_1.ProductsEnum.WOLF_MOTOR); }) || _this.state.policies.some(function (p) { return p.products.includes(services_1.ProductsEnum.HOME); }))
                && (_this.state.customerHasActivePolicy || _this.state.policyHasMtcVersion)) {
                actions.push((0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline ".concat(_this.state.hasActiveVulnerableCustomerAction ? "text-gray" : ""), onClick: function () { return _this.showVulnerableCustomerFlagConfirmation(); }, children: "".concat(!_this.state.vulnerableCustomerFlag ? "Flag" : "Unflag", " as vulnerable customer") }, "Vulnerable customer flagging action"));
                var policies = _this.state.policies
                    .filter(function (p) { return p.products.includes(services_1.ProductsEnum.WOLF_MOTOR) || p.products.includes(services_1.ProductsEnum.HOME); })
                    .filter(function (p) { return p.versions.every(function (ve) { return ve.status !== "MTC"; }); });
                if (policies && policies.length > 0 && _this.state.customerHasActivePolicy && !_this.state.deceasedFlag) {
                    var policyNumber = (_c = policies[policies.length - 1]) === null || _c === void 0 ? void 0 : _c.number;
                    var versions = policies[policies.length - 1].versions;
                    var version = versions[(versions === null || versions === void 0 ? void 0 : versions.length) - 1];
                    actions.push((0, jsx_runtime_1.jsx)(DeceasedCustomerAction_1.default, { policyNumber: policyNumber, policyVersionNumber: version.policyVersionNumber, customerReferenceNumber: _this.customerId }, "Deceased customer action"));
                }
            }
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { id: "customerActionsTree", label: "Actions", children: actions.map(function (action, i) {
                    return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: action }, "customerActionsTree-".concat(i));
                }) }));
        };
        _this.toggleVulnerableCustomerFlag = function () {
            _this.incrementLoadingQueueSize(function () {
                var _a;
                _this.supportPortalService
                    .setVulnerableCustomerFlag(_this.customerId, !_this.state.vulnerableCustomerFlag)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe(function () { return _this.setState({
                    vulnerableCustomerFlag: !_this.state.vulnerableCustomerFlag,
                }); });
                _this.supportPortalService.logAgentActivity(_this.customerId, { "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString(), "action": _this.state.vulnerableCustomerFlag ? "Unflag as Vulnerable customer" : "Flag as Vulnerable customer", "customer": "Account" }).subscribe();
            });
        };
        _this.showVulnerableCustomerFlagConfirmation = function () {
            if (!_this.state.hasActiveVulnerableCustomerAction) {
                _this.setState({ showVulnerableCustomerFlagConfirmation: true });
            }
            _this.supportPortalService.logAgentActivity(_this.customerId, { "action": "No Action", "customer": "Account" }).subscribe(function (agentAction) { return _this.setState({ agentActivityId: agentAction.id }); });
        };
        _this.toggleFraudFlag = function () {
            _this.incrementLoadingQueueSize(function () {
                var _a;
                _this.supportPortalService
                    .setFraudFlag(_this.customerId, !_this.state.fraudFlag)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe(function () { return _this.setState({
                    fraudFlag: !_this.state.fraudFlag
                }); });
                _this.supportPortalService.logAgentActivity(_this.customerId, { "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString(), "action": "Mark as fraud", "customer": "Account" }).subscribe();
            });
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.getPageTitle = function () {
            var customer = _this.state.customer;
            if (customer) {
                return "".concat(customer.firstName, " ").concat(customer.lastName, " details");
            }
            else {
                return "Customer details";
            }
        };
        _this.onActionChange = function () {
            _this.getActiveVulnerableCustomerActions();
        };
        _this.customerId = props.params.id;
        _this.state = {
            user: _this.applicationGuard.getUser(),
            showFraudFlagConfirmation: false,
            showVulnerableCustomerFlagConfirmation: false,
            loadingQueueSize: 0,
            customerHasActivePolicy: false,
            policyHasMtcVersion: false,
            renewalProposals: [],
            userIdIsCopied: false
        };
        return _this;
    }
    CustomerDetailsPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.lookupService
                .fetchLookupValues("all".concat(services_1.ProductsEnum.WOLF_MOTOR), "en-UK")
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe();
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getParty(_this.customerId)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (customer) {
                _this.setState({ customer: customer });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getVulnerableCustomerFlag(_this.customerId)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (vulnerableCustomerFlag) {
                _this.setState({ vulnerableCustomerFlag: vulnerableCustomerFlag });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getDeceasedCustomerFlag(_this.customerId)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (deceasedFlag) {
                _this.setState({ deceasedFlag: deceasedFlag });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getFraudFlag(_this.customerId)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (fraudFlag) {
                _this.setState({ fraudFlag: fraudFlag });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getPolicies(_this.customerId)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (policies) {
                _this.setState({ policies: policies });
                _this.checkIfUserHasActivePolicies(policies);
                _this.checkIfUserHasCanceledPolicies(policies);
                _this.getActiveVulnerableCustomerActions();
                _this.incrementLoadingQueueSize(function () {
                    for (var _i = 0, policies_1 = policies; _i < policies_1.length; _i++) {
                        var policy = policies_1[_i];
                        _this.supportPortalService
                            .getRenewalProposal(policy.number)
                            .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                            .subscribe(function (renewalProposal) {
                            if (renewalProposal) {
                                _this.setState({ renewalProposals: __spreadArray(__spreadArray([], _this.state.renewalProposals, true), [renewalProposal], false) });
                            }
                        });
                    }
                });
            });
        });
    };
    CustomerDetailsPagePlain.prototype.render = function () {
        if (!this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support", "Read_Only"])) {
            return this.supportPortalTemplates.renderErrorPage();
        }
        return ((0, jsx_runtime_1.jsx)(Page_1.default, { title: this.getPageTitle(), isLoading: this.state.loadingQueueSize > 0, children: (0, jsx_runtime_1.jsx)(Page_1.PageContext.Provider, { value: {
                    loadingQueue: {
                        size: this.state.loadingQueueSize,
                        increment: this.incrementLoadingQueueSize,
                        decrement: this.decrementLoadingQueueSize
                    }
                }, children: this.renderPageContent() }) }));
    };
    CustomerDetailsPagePlain.prototype.handleFraudAction = function (actions) {
        var _this = this;
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Fraud"])) {
            actions.push((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", onClick: function () { return _this.setState({ showFraudFlagConfirmation: true }); }, to: "#", children: "".concat(!this.state.fraudFlag ? "Flag" : "Unflag", " as fraud") }, "Fraud flagging action"));
        }
    };
    CustomerDetailsPagePlain.prototype.getActiveVulnerableCustomerActions = function () {
        var _this = this;
        if (this.state.policies && this.state.policies.some(function (p) { return p.products.includes(services_1.ProductsEnum.WOLF_MOTOR); })) {
            this.incrementLoadingQueueSize(function () {
                _this.supportPortalService
                    .getActiveVulnerableCustomerActions(_this.customerId)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe(function (actions) {
                    _this.setState({
                        hasActiveVulnerableCustomerAction: actions && actions.length > 0
                    });
                });
            });
        }
    };
    CustomerDetailsPagePlain.prototype.getDocumentsPreference = function () {
        if (this.state.customer && this.state.customer.customProperties !== undefined) {
            var properties = this.state.customer.customProperties;
            for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                var property = properties_1[_i];
                if (property.key === "sendDocumentsByPost" && property.value === "true") {
                    return "Postal";
                }
            }
            return "Online";
        }
        return "";
    };
    CustomerDetailsPagePlain.prototype.checkIfUserHasActivePolicies = function (source) {
        var _this = this;
        var policies = source.filter(function (p) {
            return (p.products.includes(services_1.ProductsEnum.WOLF_MOTOR) || p.products.includes(services_1.ProductsEnum.HOME))
                && !_this.policyHasMtcVersion(p);
        });
        var versions = policies && policies.length > 0 ? policies[0].versions : undefined;
        var newestPolicyVersion = versions ? versions[versions.length - 1] : undefined;
        if (newestPolicyVersion) {
            this.setState({ customerHasActivePolicy: true });
        }
    };
    CustomerDetailsPagePlain.prototype.checkIfUserHasCanceledPolicies = function (source) {
        var _this = this;
        var mtcPolicies = source.filter(function (p) {
            return (p.products.includes(services_1.ProductsEnum.WOLF_MOTOR) || p.products.includes(services_1.ProductsEnum.HOME))
                && _this.policyHasMtcVersion(p);
        });
        if (mtcPolicies && mtcPolicies.length > 0) {
            this.setState({ policyHasMtcVersion: true });
        }
    };
    CustomerDetailsPagePlain.prototype.policyHasMtcVersion = function (policy) {
        return policy.versions.some(function (version) { return version.status === "MTC"; });
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], CustomerDetailsPagePlain.prototype, "applicationGuard", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CustomerDetailsPagePlain.prototype, "supportPortalService", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconLookupService),
        __metadata("design:type", Object)
    ], CustomerDetailsPagePlain.prototype, "lookupService", void 0);
    CustomerDetailsPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CustomerDetailsPagePlain);
    return CustomerDetailsPagePlain;
}(React.Component));
exports.CustomerDetailsPagePlain = CustomerDetailsPagePlain;
exports.default = (0, components_1.withRouter)(CustomerDetailsPagePlain);
//# sourceMappingURL=CustomerDetailsPage.js.map